import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button } from "@ts-digital/vrc";
import { Alert } from "antd";
import { NEW_COOKIE_POLICY_URL, COMMON_LOGIN_URL, LOGIN_METHOD } from "../../config";
import DefaultLogin from "./default-login";
import ExpiredPassword from "./expired-password";
import { forgotPassword, login, resetLogin } from "../../store/actions/auth/index";
import { updatePassword } from "../../store/actions/users/index";
import { unifiedLoginSuccess } from "../../store/actions/auth/index";
import tsDigitalLogo from "../../assets/img/tsDigitalLogo.png";
import Circle from "./circle";
import { themes } from "./theme";
import {
  A,
  AdvertisingContainer,
  Container,
  ContentWrapper,
  Copyright,
  Header,
  LoginContainer,
  Logo,
  LogoContainer,
  Sidebar,
  Title,
  ImgLoginContainer,
  ImgLoginTitle,
  ImgLoginDescription,
  HumanImageContainer,
  HumanImage,
  CirclesContainer,
  HighlightWord
} from "./styled";
import "./style.css";
import { LoginButton } from "@ts-digital/digital-login-component";
import { FormattedMessage } from "react-intl";
import { advertisement } from "./advertisements";

class Login extends Component {
  static propTypes = {
    location: PropTypes.any,
    auth: PropTypes.object,
    forgotPassword: PropTypes.func,
    login: PropTypes.func,
    pathname: PropTypes.string,
    resetLogin: PropTypes.func,
    sso: PropTypes.object,
    updatePassword: PropTypes.func,
    setFirstLogin: PropTypes.func,
    unifiedLoginSuccess: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      isClicked: false,
      toLogin: true
    };
    this.childDefault = React.createRef();
    this.childExpired = React.createRef();
    this.childForgotPwd = React.createRef();
  }

  setIsClicked(value) {
    this.setState({ isClicked: value });
  }

  setToLogin(value) {
    this.setState({ toLogin: value });
  }

  constructContentPrelogin() {
    let contentObj;
    let struct = this.getDefaultStructPrelogin();
    contentObj = {
      node: struct.node,
      footer: struct.footer
    };
    return contentObj;
  }

  getDefaultStruct() {
    let contentJson = {
      node: (
        <DefaultLogin
          buttonLink={
            <Link to="sso">
              <Button style={{ width: "100%" }}>TeamSystem ID</Button>
            </Link>
          }
          isForgotLink={true}
          messageInfo={
            <div>
              Accedi con <b>TeamSystem ID</b>,<br /> l’identificativo universale per accedere alle piattaforme gestionali, nel rispetto dei requisiti <br />
              di sicurezza previsti dal GDPR.
            </div>
          }
          isClicked={this.state.isClicked}
          putIsClicked={this.setIsClicked.bind(this)}
          isSso={false}
          toLogin={this.state.toLogin}
          putToLogin={this.setToLogin.bind(this)}
        />
      ),
      footer: this.state.toLogin ? (
        <Button
          className={"gs-login-no-tsid"}
          kind={"secondary"}
          colorScheme={"ghost"}
          style={{ width: "calc(100% - 64px)" }}
          onClick={(e) => {
            this.setState({ isClicked: true });
            this.props.setFirstLogin(true);
          }}
        >
          Entra senza TeamSystem ID
        </Button>
      ) : null
    };
    return contentJson;
  }

  getExpiredPasswordStruct() {
    const { auth, resetLogin, updatePassword } = this.props;
    let contentJson = {
      node: (
        <div>
          <Alert
            message="Attenzione!"
            description={"Password scaduta per " + auth.oldAuth.id + ". Inserisci una nuova password."}
            type="warning"
            showIcon
            style={{ wordBreak: "break-word" }}
          />
          <ExpiredPassword auth={auth} email={auth.oldAuth.id} resetLogin={resetLogin} updatePassword={updatePassword} ref={this.childExpired} />
        </div>
      ),
      footer: (
        <div
          style={{
            width: "calc(100% - 64px)",
            textAlign: "center",
            margin: "0 32px",
            display: "flex"
          }}
        >
          <Button
            kind={"secondary"}
            colorScheme={"ghost"}
            style={{ flex: "1 0 auto", marginRight: "16px" }}
            onClick={(e) => {
              this.childExpired.current.handleSubmit(e);
            }}
          >
            Conferma
          </Button>
          <Button
            kind={"secondary"}
            colorScheme={"ghost"}
            style={{ flex: "1 0 auto" }}
            onClick={(e) => {
              resetLogin();
            }}
          >
            Annulla
          </Button>
        </div>
      )
    };
    return contentJson;
  }

  getDefaultStructPrelogin() {
    const { unifiedLoginSuccess } = this.props;
    function onSuccessLogin(e) {
      unifiedLoginSuccess(
        "DIGITALBOXWEB", e.id, e.token, e.refreshToken, e.loginMethod, e.idToken
      );
    }

    return (
      <LoginButton
        buttonText={<FormattedMessage id="actions.login" />}
        displayedAppName="DigitalBox"
        mode="tab"
        onLoginSuccess={(e) => {
          onSuccessLogin(e);
        }}
        loginUrl={COMMON_LOGIN_URL}
        loginMethod={LOGIN_METHOD}
      ></LoginButton>
    );
  }

  render() {
    return (
      <Container>
        <Header>
          <FormattedMessage id="generalText.ts" />
        </Header>
        <ContentWrapper>
          <Sidebar>
            <LogoContainer>
              <Logo src={tsDigitalLogo} alt="ts digital logo" />
            </LogoContainer>
            <LoginContainer>
              <Title>
                <FormattedMessage id="prelogin.title" />
              </Title>
              {this.getDefaultStructPrelogin()}
            </LoginContainer>
            <Copyright>
              <FormattedMessage id="prelogin.copyright" />
              <span>|</span>
              <span>
                <A href="https://tc.teamsystem.com/InformativaPrivacyTSDigital.pdf" target="_blank" rel="noopener noreferrer">
                  <FormattedMessage id="prelogin.privacyPolicy" />
                </A>{" "}
                ·{" "}
                <A href={NEW_COOKIE_POLICY_URL} target="_blank" rel="noopener noreferrer">
                  <FormattedMessage id="prelogin.cookie" />
                </A>
              </span>
            </Copyright>
          </Sidebar>
          <AdvertisingContainer>
            <ImgLoginContainer>
              <ImgLoginTitle>
                <FormattedMessage
                  id={"prelogin.advertisingTitle"}
                  values={{ highlight: (chunks) => <HighlightWord color={"#c53090"}>{chunks}</HighlightWord> }}
                />
              </ImgLoginTitle>
              <ImgLoginDescription>
                <FormattedMessage id="prelogin.subtitle" />
              </ImgLoginDescription>
              <CirclesContainer>
                <Circle size={"large"} value={"200+"} valueType={<FormattedMessage id="prelogin.thousands" />} description={<FormattedMessage id="prelogin.managedCompanies" />} themeColors={themes["rose"].circle} />
              </CirclesContainer>
              <HumanImageContainer right="-60px" top="120px">
                <HumanImage src={advertisement.image.url} />
              </HumanImageContainer>
            </ImgLoginContainer>
          </AdvertisingContainer>
        </ContentWrapper>
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    sso: state.sso,
    user: state.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    forgotPassword: bindActionCreators(forgotPassword, dispatch),
    login: bindActionCreators(login, dispatch),
    resetLogin: bindActionCreators(resetLogin, dispatch),
    updatePassword: bindActionCreators(updatePassword, dispatch),
    unifiedLoginSuccess: bindActionCreators(unifiedLoginSuccess, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
